import { render, staticRenderFns } from "./partnerCurrentDeductionComponent.vue?vue&type=template&id=79d884ec&scoped=true&"
import script from "./partnerCurrentDeductionComponent.vue?vue&type=script&lang=js&"
export * from "./partnerCurrentDeductionComponent.vue?vue&type=script&lang=js&"
import style0 from "./partnerCurrentDeductionComponent.vue?vue&type=style&index=0&id=79d884ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d884ec",
  null
  
)

export default component.exports